import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { CompetitionTeam } from './competition-team'
import * as fromCompetitionTeam from './competition-team.reducer'

const state = createFeatureSelector<fromCompetitionTeam.CompetitionTeamState>(
  fromCompetitionTeam.FEATURE_NAME
)

const adapter = fromCompetitionTeam.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)
const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<CompetitionTeam>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: CompetitionTeam[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

const selectInvitedStaffMembers = createSelector(
  state,
  (state) => state.invitedStaffMembers
)

const selectInvitedPlayers = createSelector(
  state,
  (state) => state.invitedPlayers
)

const selectPaginationDetails = createSelector(
  state,
  (state) => state.paginationDetails
)

export const competitionTeamSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectCount,
  selectInvitedStaffMembers,
  selectInvitedPlayers,
  selectPaginationDetails
}
